import { LOAD_SUPPORTED_COUNTRIES, LOAD_SUPPORTED_LANGUAGES, LOAD_SUPPORTED_SPORTS, LOAD_RATINGS } from "../actions";
import { Sport } from "../types";

export const initialState = {
	countries: [],
	languages: [],
	sports: [] as Sport[],
	ratings: {},
};

export type UtilityState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case LOAD_SUPPORTED_COUNTRIES: {
			const countries = action.countries;
			return { ...state, countries };
		}

		case LOAD_SUPPORTED_LANGUAGES: {
			const languages = action.languages;
			return { ...state, languages };
		}

		case LOAD_SUPPORTED_SPORTS: {
			const sports = action.sports;
			sports.sort((sport1, sport2) => {
				return sport1.priority - sport2.priority;
			});
			return { ...state, sports };
		}

		case LOAD_RATINGS: {
			const ratings = action.ratings;
			return { ...state, ratings };
		}

		default:
			return state;
	}
}
